/* eslint-disable tailwindcss/no-arbitrary-value */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardMedia,
  CardTitle,
  CardBody,
  CardActions,
  Typography,
  Button,
  Link,
  CardFooter,
} from '@one-thd/sui-atomic-components';
import { useImpression } from '@thd-olt-component-react/impression';

export const PromoVisualNavigationCard = (itemDetails) => {
  const { item, position } = itemDetails;
  let {
    image, id: itemID, link, promotionalOffer, previewImage
  } = item || {};

  let { description: altText, url: imageUrl } = image || {};

  const { ref, clickID } = useImpression({
    data: {
      id: itemID,
      component: 'PromoVisualNavigation',
      name: 'PromoVisualNavigation',
      type: 'content',
      position,
    },
  });

  if (previewImage) {
    let damDownloadedContentImage = previewImage?.damDownloadedContent;
    let damContentSelectorImage = previewImage?.damContentSelector?.assetData?.[0];

    if (damDownloadedContentImage?.url) {
      imageUrl = damDownloadedContentImage?.url;
    } else {
      imageUrl = damContentSelectorImage?.selectedImageUrl || imageUrl;
    }
  }

  const { simpleOfferHeadline, simpleOfferSubhead } = promotionalOffer || {};

  const {
    eyebrow, shouldShowDollar, shouldShowOff, specialOfferHeadline, specialOfferSubhead
  } = promotionalOffer || {};

  const eyebrowSection = (
    <CardTitle subheader={(<Typography variant="h5" height="tight" weight="display">{eyebrow}</Typography>)} />
  );

  const dollarSection = (
    <Typography variant="h5" height="tight" weight="display"><sup className="sui-top-3 sui-align-super sui-mr-[0.13rem] sui-text-lg">$</sup></Typography>
  );

  const offSection = (
    <Typography variant="h5" height="tight" weight="display"><sub className="sui-top-3 sui-ml-[0.4rem] sui-text-lg">Off</sub></Typography>
  );

  const titleSection = (
    <>
      {simpleOfferHeadline
        ? (
          <CardTitle header={<Typography variant="h3" weight="display" height="tight">{simpleOfferHeadline}</Typography>} />
        )
        : (
          <>
            {eyebrow && eyebrowSection}
            <div className="sui-flex">
              {shouldShowDollar && dollarSection}
              <CardTitle header={<Typography variant="h2" weight="display" height="tight">{specialOfferHeadline}</Typography>} />
              {shouldShowOff && offSection}
            </div>
          </>
        )}
    </>
  );

  const subTitleSection = (
    <>
      {simpleOfferSubhead
        ? <CardBody><Typography height="normal">{simpleOfferSubhead}</Typography></CardBody>
        : <CardBody><Typography height="normal">{specialOfferSubhead}</Typography></CardBody>}
    </>
  );

  return (
    <div
      ref={ref}
      /* eslint-disable-next-line react/no-unknown-property */
      clickid={clickID}
      key={`card-position-${position}`}
      className="sui-flex sui-w-full"
    >
      <Card
        key={itemID}
        target="_blank"
        rel="noreferrer"
        className="sui-w-full sui-grid"
      >
        <CardMedia
          alt={`Image for ${altText || simpleOfferHeadline || specialOfferHeadline}`}
          title={`Image for ${altText || simpleOfferHeadline || specialOfferHeadline}`}
          src={imageUrl}
          aspect="square"
        />
        <div className="sui-flex-row sui-grow">
          {titleSection}
          {subTitleSection}
        </div>
        <Button href={link} variant="text">Shop Now</Button>
      </Card>
    </div>
  );
};

const displayName = 'PromoVisualNavigationCard';

const propTypes = {
};

const defaultProps = {
};

PromoVisualNavigationCard.displayName = displayName;
PromoVisualNavigationCard.propTypes = propTypes;
PromoVisualNavigationCard.defaultProps = defaultProps;